import React, { useState, useRef, useEffect, useMemo } from "react";
import { Button, TextBox, Accordion } from 'devextreme-react';
import RadioGroup, { RadioGroupTypes } from 'devextreme-react/radio-group';
import notify from 'devextreme/ui/notify';
import * as Fnctn from '../../contexts/GenericFunctions';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';
import * as FireBase from '../../contexts/FirebaseActions';
import { Audiencia } from '../../components/Tasks/componentTasks';
import '../NuevoCurso/NuevoCurso.scss'
let segmentacion: any = {
    areas: [],
    branches: [],
    companies: [],
    type_collaborators: []
};

interface IState {
    handlePopupHidden: () => void;
    base_64_image: string
    foto_curso: string
    titulo_curso: string
    visible_audiencia: boolean
    nuevo_curso: boolean
    visible_curso_generado: boolean
}
function NuevoCurso (state: IState) {
    let api = Fnctn.GetAPI();
    const [base64Image, setBase64Image] = useState<string>(state.base_64_image);
    const [FotoTarea, setFotoTarea] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [Titulo, setTitulo] = useState<string>(state.titulo_curso);
    const [accordionCm, setaccordionCm] = useState<any>([]);
    const [VisibleAudiencia, setVisibleAudiencia] = useState<boolean>(state.visible_audiencia);
    const [dtArea] = useState<any>([]);
    const [dtEmpresa] = useState<any>([]);
    const [dtSucursal] = useState<any>([]);
    const [CursoGenerado, setCursoGenerado] = useState<boolean>(state.visible_curso_generado);
    const itemsAccordion = [
        { title: 'Area', Codigo: "areas" },
        { title: 'Sucursal', Codigo: 'branches' },
        { title: 'Empresa', Codigo: 'companies' }
    ];

    const ItemsAudiencia = [
        { Codigo: false, Nombre: 'Todos los usuarios' },
        { Codigo: true, Nombre: 'Segmentar' }
    ];

    useEffect(() => {
        setaccordionCm(<Accordion
            dataSource={itemsAccordion}
            animationDuration={500}
            itemRender={itemRenderAccordion}
            id="accordion-container"
            style={{ margin: "0px 0px 0px 45px", width: "89%" }}
        />)
    }, [NuevoCurso]);

    const returnIds = (arrayObj: any) => {
        let arrayIds: any = []
        arrayObj.forEach((element: any) => {
            arrayIds.push(element._id);
        });
        return arrayIds;
    }

    const getIds = (ids: any, list: string) => {
        if (list === "areas") {
            segmentacion.areas = [ids[0]]
        }
        else if (list === "branches") {
            segmentacion.branches = [ids[0]]
        }
        else if (list === "companies") {
            segmentacion.companies = [ids[0]]
        }

        console.log(segmentacion);
    };

    const itemRenderAccordion = useMemo(() => (itemData: any) => {
        return (
            <Audiencia props={itemData} selectedItems={/*props.Select_Segmentacion*/[]} getIds={getIds}></Audiencia>
        )
    }, [dtArea.data, dtSucursal.data, dtEmpresa.data]);

    const handleTextChanged = (e: any, Textbox: string = "") => {
        if (Textbox === "Titulo") setTitulo(e.value);
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        setFotoTarea(file)
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String: string = reader.result!.toString();
                setBase64Image(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const getLastIndex = async () => {
        const data = Fnctn.getCookie();
        const dtresult = await fetch(`${api}/catalogs/courses`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${data.token}`
            }
        });
        const dtCourses = await dtresult.json();
        let max: number = -1
        dtCourses.data[0].forEach((element: any) => {
            if (max < element.order) {
                max = element.order
            }
        });

        return max + 1
    }

    const Guardar = async () => {
        try {
            if (!Fnctn.NullUndefinedEmpty(Titulo)) {
                halcoloaderActive();
                const data = Fnctn.getCookie();
                let index = await getLastIndex();
                if (!Fnctn.NullUndefinedEmpty(FotoTarea)) {
                    let IconoCurso = await FireBase.uploadFile(FotoTarea, FireBase.enumPath.ICONOS_CURSOS);
                    if (!VisibleAudiencia) {
                        segmentacion = {
                            "areas": [],
                            "branches": [],
                            "companies": [],
                            "type_collaborators": []
                        };
                    }

                    let Objt = {
                        "name": Titulo
                        , "description": ""
                        , "img_path": IconoCurso.PathFireBase
                        , "img_name": IconoCurso.NameFirebase
                        , "order": index
                        , "segmentation": segmentacion
                        , "assignated": VisibleAudiencia
                    }
                    let dtCursos = await fetch(`${api}/catalogs/courses`,
                        {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${data.token}`
                            },
                            body: JSON.stringify(Objt)
                        }
                    );

                    console.log(await dtCursos.json())
                    halcoloaderRemove();
                    notify("Curso agregado correctamente", "success");
                    setCursoGenerado(true);
                }
                else {
                    halcoloaderRemove();
                    notify("Debes agregar una imagen para el ícono de el curso", "error")
                }
            }
            else {
                halcoloaderRemove();
                notify("Debes agregar un título a el curso", "error")
            }
        }
        catch (error) {
            halcoloaderRemove();
            notify(error, 'error');
        }
    };

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const changeSelectionRB = (e: RadioGroupTypes.ValueChangedEvent, Radio: String) => {
        if (!e.value) setVisibleAudiencia(false);
        else {
            setVisibleAudiencia(true);
            setaccordionCm(<Accordion
                dataSource={itemsAccordion}
                animationDuration={500}
                itemRender={itemRenderAccordion}
                id="accordion-container"
                style={{ margin: "0px 0px 0px 35px", width: "85%" }}
            />)
            // GetAudiencias();
        }
    };

    return (
        <React.Fragment>
            <div className={'content-course dx-card responsive-paddings'}>
                <div style={{ margin: '0px 0px 40px 0px' }}><label style={{ fontSize: '25px' }}>Nuevo Curso</label></div>
                <div>
                    <div className={'form-avatar'}  onClick={handleClick}>
                        <img
                            alt={''}
                            src={base64Image}
                            style={{ width: '100%', height: '100%', objectFit: 'contain', borderColor: "#000" }}
                        />
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                        />
                    </div>
                    <div style={{ margin: '0px 0px 0px 20%', width: "75%" }}>
                        <TextBox
                            label='Titulo'
                            placeholder='Debes ingresar un título'
                            onValueChanged={(e) => handleTextChanged(e, "Titulo")}
                            value={Titulo}
                        ></TextBox>
                        <Button
                            style={{ margin: '15px 0px 0px 0px' }}
                            stylingMode='contained'
                            type='success'
                            text='Guardar'
                            onClick={() => Guardar()}
                        ></Button>
                    </div>
                    <div style={{ margin: '0px 0px 20px 50px', display: "flex" }}>
                        <RadioGroup
                            id="radio-group-with-selection"
                            className="rdAudiencia"
                            items={ItemsAudiencia}
                            value={VisibleAudiencia}
                            valueExpr="Codigo"
                            displayExpr="Nombre"
                            onValueChanged={(e) => changeSelectionRB(e, "Audiencia")}
                            onInitialized={() => { }}
                        /><br></br>
                    </div>
                    {
                        VisibleAudiencia &&
                        <div id="accordion">
                            {accordionCm}
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default NuevoCurso